/**
 * MIN-294 — no `PromptInputProvider` here any more. It lifts a composer's
 * text and attachment state above the composer, and this layout mounted it so
 * the two chat routes could share both across the navigation between them.
 * Neither still needs it: the draft now lives in `AgentChat.Root`'s context
 * (which controls the textarea's value directly), and the attachment state it
 * lifted was never read — this app renders no attachment surface. Its only
 * remaining effect was to point `elements/PromptInput` at a permanently empty
 * lifted file list instead of its own equally empty local one.
 */
import { chatThreadQueries } from "@repo/agent-chat";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { useEffect } from "react";
import { ChatLayoutButtonGroup } from "@/components/chat-layout-button-group";
import { ChatSessionsPanel } from "@/components/chat-sessions-panel";
import { useChatSidebar } from "@/context/chat-sidebar-context";
import { API_BASE_URL } from "@/lib/api-client";
import { medplum } from "@/lib/medplum";

export const Route = createFileRoute("/chat/_layout")({
  component: ChatLayout,
});

function ChatLayout() {
  const { toggleSidebar, closeSidebar } = useChatSidebar();

  // Close sidebar when navigating away from chat
  // biome-ignore lint/correctness/useExhaustiveDependencies: only run cleanup on unmount
  useEffect(() => {
    return () => closeSidebar();
  }, []);
  const { data: threads = [] } = useQuery(chatThreadQueries.list(medplum, API_BASE_URL));

  return (
    <div className="flex flex-1 min-h-0">
      <ChatSessionsPanel threads={threads} />
      <div className="flex-1 min-w-0 overflow-hidden flex flex-col">
        <ChatLayoutButtonGroup toggleSidebar={toggleSidebar} />
        <div className="flex-1 min-h-0 flex flex-col">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
